
import type { SuggestedCandidate } from "@/types/candidateSuggestion";

export const mockSuggestedCandidates: SuggestedCandidate[] = [
  {
    id: "mock-candidate-1",
    name: "Alex Johnson",
    skills: ["React", "TypeScript", "Node.js", "GraphQL", "AWS"],
    experience_years: 5,
    location: "San Francisco, CA",
    match_score: 95,
    match_reasons: {
      skills: ["React", "TypeScript", "Node.js"],
      experience: "5 years",
      location: "San Francisco, CA"
    },
    email: "alex.johnson@example.com",
    phone: "+1 (555) 123-4567",
    linkedin_url: "https://linkedin.com/in/alex-johnson",
    status: "interview"
  },
  {
    id: "mock-candidate-2",
    name: "Sam Rivera",
    skills: ["UI Design", "UX Research", "Figma", "Adobe XD", "Prototyping"],
    experience_years: 3,
    location: "Austin, TX",
    match_score: 88,
    match_reasons: {
      skills: ["UI Design", "UX Research", "Figma"],
      experience: "3 years",
      location: "Austin, TX"
    },
    email: "sam.rivera@example.com",
    phone: "+1 (555) 987-6543",
    linkedin_url: "https://linkedin.com/in/sam-rivera",
    status: "contacted"
  },
  {
    id: "mock-candidate-3",
    name: "Maya Patel",
    skills: ["Product Management", "Agile", "Healthcare", "User Research", "Roadmapping"],
    experience_years: 7,
    location: "Boston, MA",
    match_score: 82,
    match_reasons: {
      skills: ["Product Management", "Agile", "User Research"],
      experience: "7 years",
      location: "Boston, MA"
    },
    email: "maya.patel@example.com",
    phone: "+1 (555) 456-7890",
    linkedin_url: "https://linkedin.com/in/maya-patel",
    status: "offer"
  }
];
